import type { ComponentProps, ReactNode } from 'react';
import { Avatar } from '../avatar';
import { Col } from '../col';
import { Row } from '../row';
import { Text } from '../typography';

type P = {
  avatar: ComponentProps<typeof Avatar>;
  extra?: ReactNode;
  user: {
    isViewer?: boolean;
    name: string;
  };
};

// TODO: rename
const AvatarWrapper = ({ avatar, extra, user }: P) => (
  <Row align="middle" className="avatar-wrapper" gutter={[0, 'xxs']} justify="space-between">
    <Col className="avatar-wrapper__image">
      <Avatar size={32} {...avatar} />
    </Col>

    <Col textAlign="center">
      {/** TODO: ellipsis? */}
      <Text type="title">
        {user.name}
        {user.isViewer ? (
          <>
            <br />
            <Text size="small" type="title">
              (You)
            </Text>
          </>
        ) : null}
      </Text>
    </Col>

    {extra ? <Col textAlign="center">{extra}</Col> : null}
  </Row>
);

export default AvatarWrapper;
